import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconPaymentCheckoutLink = createIcon({
  viewBox: '0 0 56 56',
  path: (
    <>
      <path
        d="M35.5104 18.8943C32.4295 15.8027 28.2574 14.045 23.893 14L23.8075 14C20.3981 14.3358 17.2118 15.8476 14.7951 18.2759L13.0124 20.0587L2.48703 30.584C2.38861 30.6827 2.33334 30.8164 2.33334 30.9557C2.33334 31.0951 2.38861 31.2287 2.48703 31.3274L2.95409 31.7879C4.38475 33.2161 6.08283 34.3484 7.95127 35.1201C9.81972 35.8917 11.8219 36.2877 13.8434 36.2852C15.865 36.2828 17.8662 35.882 19.7328 35.1058C21.5993 34.3296 23.2947 33.1932 24.7219 31.7616L36.188 20.3086C36.2864 20.21 36.3417 20.0763 36.3417 19.937C36.3417 19.7976 36.2864 19.664 36.188 19.5653L35.5104 18.8943Z"
        fill="#00A69C"
      />
      <path
        style={{ mixBlendMode: 'multiply' }}
        d="M36.5629 19.9205L35.5104 18.8943C32.4174 15.7967 28.2308 14.0389 23.8535 14C20.4279 14.3305 17.2246 15.8449 14.7951 18.2825L13.0124 20.0587L24.7219 31.7616L29.9846 37.0243C31.538 38.5821 33.3835 39.818 35.4154 40.6614C37.4473 41.5047 39.6257 41.9388 41.8256 41.9388C44.0256 41.9388 46.2039 41.5047 48.2358 40.6614C50.2677 39.818 52.1133 38.5821 53.6667 37.0243L36.5629 19.9205Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="13.0124"
          y1="27.9724"
          x2="53.6601"
          y2="27.9724"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF100" />
          <stop offset="0.17" stopColor="#C8E122" />
          <stop offset="0.39" stopColor="#82CC4D" />
          <stop offset="0.6" stopColor="#4ABC6F" />
          <stop offset="0.78" stopColor="#22B087" />
          <stop offset="0.92" stopColor="#09A996" />
          <stop offset="1" stopColor="#00A69C" />
        </linearGradient>
      </defs>
    </>
  ),
});

export default IconPaymentCheckoutLink;
